import GridContainer from 'components/GridContainer';
import Spacing from 'components/Spacing';
import {
  HoldingClassInvestmentsConsiderationValues,
  InvestmentAllocation,
  InvestorAllocationTotals,
} from '../../types';
import HoldingClassSplitPerInvestmentTable from './HoldingClassSplitPerInvestmentTable';
import { CurrencyCode } from 'further-types/lp/vehicle';
import Heading from 'components/Heading';
import Button from 'components/Button';
import ButtonGroup from 'components/ButtonGroup';
import { styled, Grid } from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import useFormatInvestorAllocationsData from './InvestmentSplitPerInvestorTable/useFormatInvestorAllocationsData';
import InvestmentSplitPerInvestorTable from './InvestmentSplitPerInvestorTable';
import PerInvestorAllocationTable from '../../AllocationTables/PerInvestorAllocationTable';
import PerClassAllocationTable from '../../AllocationTables/PerClassAllocationTable';

type Props = {
  holdingClassInvestmentsConsiderationValues: Array<HoldingClassInvestmentsConsiderationValues>;
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
  currency: CurrencyCode;
  considerationIndex: number;
};

const StyledButton = styled(Button)({
  paddingLeft: '0',
  paddingRight: '0',
});

const AllocationsTableSection: React.FC<Props> = ({
  holdingClassInvestmentsConsiderationValues,
  investorAllocationsTotals,
  currency,
  considerationIndex,
}) => {
  const { getValues } = useFormContext<rules.CreateRealisationFormValues>();
  const [showPerInvestment, setShowPerInvestment] = useState(false);
  const [showPerInvestor, setShowPerInvestor] = useState(false);
  const holdingClassRealisations = getValues('holdingClassRealisation');

  const { formatInvestorAllocationsData } = useFormatInvestorAllocationsData();
  const tableData = formatInvestorAllocationsData(considerationIndex);

  const flatInvestmentAllocations = getValues(
    `consideration.${considerationIndex}.investorAllocations`,
  );

  const groupedPerInvestmentAllocations = Object.values(tableData);

  return (
    <GridContainer>
      <Grid size={{ md: 10, xs: 12 }}>
        <Spacing size="md">
          <Heading variant="h2" noMargin>
            Per class allocation
          </Heading>
          <PerClassAllocationTable
            holdingClassRealisations={holdingClassRealisations}
            currency={currency}
          />
          <ButtonGroup align="left">
            <StyledButton
              variant="text"
              type="button"
              color="primary"
              onClick={() => setShowPerInvestment(!showPerInvestment)}
            >
              {showPerInvestment
                ? `Hide class split by investment >`
                : `See class split by investment >`}
            </StyledButton>
          </ButtonGroup>
          {showPerInvestment && (
            <HoldingClassSplitPerInvestmentTable
              holdingClassInvestmentsConsiderationValues={
                holdingClassInvestmentsConsiderationValues
              }
              currency={currency}
            />
          )}
          <Heading variant="h2" noMargin>
            Per investor allocation
          </Heading>
          <PerInvestorAllocationTable
            currency={currency}
            investorAllocationsTotals={investorAllocationsTotals}
          />
          <ButtonGroup align="left">
            <StyledButton
              variant="text"
              type="button"
              color="primary"
              onClick={() => setShowPerInvestor(!showPerInvestor)}
            >
              {showPerInvestor
                ? `Hide investor split by investment >`
                : `See investor split by investment >`}
            </StyledButton>
          </ButtonGroup>
          {showPerInvestor && (
            <>
              {groupedPerInvestmentAllocations.map(
                //@ts-expect-error Needs to be fixed - Realisations
                (investmentAllocation: Array<InvestmentAllocation>) => {
                  return (
                    <InvestmentSplitPerInvestorTable
                      key={`${investmentAllocation[0].investmentId}-table`}
                      currency={currency}
                      considerationIndex={considerationIndex}
                      investmentAllocation={investmentAllocation}
                      //@ts-expect-error Needs to be fixed - Realisations
                      flatInvestmentAllocations={
                        flatInvestmentAllocations ?? []
                      }
                    />
                  );
                },
              )}
            </>
          )}
        </Spacing>
      </Grid>
    </GridContainer>
  );
};

export default AllocationsTableSection;
